const formatterCache = new Map<string, Intl.NumberFormat>();

function getCurrencyFormatter(
  locale: string,
  currency: string | undefined,
  fractionDigits: 0 | 2,
): Intl.NumberFormat {
  const cacheKey = `${locale}-${currency}-${fractionDigits}`;
  let formatter = formatterCache.get(cacheKey);
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: fractionDigits,
    });
    formatterCache.set(cacheKey, formatter);
  }
  return formatter;
}

export function formatCurrency(
  currency: string | undefined,
  amount: number,
  locale: string,
): string {
  switch (currency) {
    case "NOK":
      return `${amount} kr`;
    case "GBP":
      return `£${amount}`;
  }

  try {
    return getCurrencyFormatter(
      locale,
      currency,
      Number.isInteger(amount) ? 0 : 2,
    ).format(amount);
  } catch {
    const errorMessage = `Unknown currency: ${currency}`;
    if (process.env.NODE_ENV === "development") {
      throw new Error(errorMessage);
    }
    void import("@/lib/logger").then(({ logger }) =>
      logger.error({ msg: errorMessage }),
    );
    return `${amount}`;
  }
}
